import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Services ---
import { LocalStorageService } from '@services/local-storage.service';

// --- Interfaces ---
import type { IMenuLayout } from '@interfaces/menuLayout';

export const INITIAL_STATE: IMenuLayout = {};

@Injectable({
	providedIn: 'root',
})
export class MenuLayoutStore {
	private _menuLayoutState = new BehaviorSubject<IMenuLayout>(
		this.stateStorage || INITIAL_STATE
	);
	readonly menuLayoutState$ = this._menuLayoutState.asObservable();

	constructor(private localStorageService: LocalStorageService) {}

	get stateStorage() {
		return this.localStorageService.get<IMenuLayout>('menuLayout');
	}

	updateMenuLayout(menuLayouts: IMenuLayout) {
		const state = this._menuLayoutState.value;

		const data = { ...state, ...menuLayouts };

		this._menuLayoutState.next(data);
		this.localStorageService.set('menuLayout', data);

		return this.menuLayoutState$;
	}
}
